<template>
  <div id="color-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5">{{naviVisibleList.findIndex(item => item.text === 'RGBオルソ画像') - 1}}. RGBオルソ画像</p>
      <v-img
          style="border: 1px solid black"
          contain
          ref="img"
          eager
          lazy-src="@/assets/images/no-image.png"
          class="image"
          max-height="65%"
          :src="src"
          :key="src"
          @load="doneLoading"
      >
        <template v-slot:placeholder>
          <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
          >
            <v-progress-circular
                v-if="loadingStatus"
                :size="70"
                :width="7"
                indeterminate
                color="grey lighten-5"
            ></v-progress-circular>
            <v-icon
                v-if="!loadingStatus"
                x-large
                color="red darken-1"
            >
              mdi-alert
            </v-icon>
          </v-row>
        </template>
      </v-img>
      <div class="ma-16 mt-5 mb-0">
        <v-row align-content="center" class="ma-2" v-show="report['cell'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['cell'] ? 'disabled' : ''">
            <div class="div-rounded cell ml-5"></div>
            <span class="ml-5">ホットスポット</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="cell" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['cell']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['multicell'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['multicell'] ? 'disabled' : ''">
            <div class="div-rounded multicell ml-5"></div>
            <span class="ml-5">マルチホットスポット</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="multicell" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['multicell']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['cluster'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['cluster'] ? 'disabled' : ''">
            <div class="div-rounded cluster ml-5"></div>
            <span class="ml-5">クラスタバイパス</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="cluster" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['cluster']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['module'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['module'] ? 'disabled' : ''">
            <div class="div-rounded module ml-5"></div>
            <span class="ml-5">モジュール異常</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="module" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['module']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['string'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['string'] ? 'disabled' : ''">
            <div class="div-rounded string ml-5"></div>
            <span class="ml-5">ストリング異常</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="string" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['string']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['junction'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['junction'] ? 'disabled' : ''">
            <div class="div-rounded junction ml-5"></div>
            <span class="ml-5">ジャンクションボックス過熱</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="junction" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['junction']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['pid'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['pid'] ? 'disabled' : ''">
            <div class="div-rounded pid ml-5"></div>
            <span class="ml-5">ＰＩＤ現象の疑い</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="pid" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['pid']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="report['shadow'] || editMode">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['shadow'] ? 'disabled' : ''">
            <div class="div-rounded shadow ml-5"></div>
            <span class="ml-5">影</span>
          </div>
          <div v-show="editMode">
            <v-checkbox label="表示" hide-details class="mt-0 pt-0" value="shadow" v-model="filter" @change="changeFilterReport" :disabled="!annotationTypes['shadow']"></v-checkbox>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="editMode">
          <div style="width: 260px"></div>
          <v-btn rounded color="primary" @click="filterColorPage">
            適用
          </v-btn>
        </v-row>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'RGBオルソ画像') + 1}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ColorPage",
  props: ['report', 'naviVisibleList', 'cropImagePageNum', 'openReportDialog', 'pdfPageNum', 'filterReport', 'editMode', 'annotationTypes'],
  data() {
    return {
      src: null,
      folderId: this.$route.params.folderId,
      loadingStatus: true,
      filter: []
    }
  },
  methods: {
    getColorImage(){
      this.filter = this.filterReport;
      if (this.editable){
        this.axios
            .get('/api/report/color/' + this.folderId)
            .then((response) => {
              this.report.colorSrc = response.data;
              this.src = response.data.concat('?timestamp=' + Date.now());
            })
            .catch(() => {
              this.loadingStatus = false;
              const navi = this.naviVisibleList.find(item => item.text === 'RGBオルソ画像');
              if (navi){
                navi.visible = false;
              }
              this.doneLoading();
            })
      }
      else {
        if (this.report.colorSrc){
          this.src = this.report.colorSrc.concat('?timestamp=' + Date.now());
        }
        else {
          this.loadingStatus = false;
          const navi = this.naviVisibleList.find(item => item.text === 'RGBオルソ画像');
          if (navi){
            navi.visible = false;
          }
          this.doneLoading();
        }
      }
    },
    doneLoading(){
      this.$emit('doneLoadingImage', 'color');
    },
    changeFilterReport(){
      this.$emit('changeFilterReport', this.filter);
    },
    filterColorPage(){
      store.showLoadingOverlay(true);
      this.axios
          .post('/api/report/filter/' + this.folderId, {filter: this.filter})
          .then((response) => {
            this.report.filter = response.data.report.filter;
            this.src = response.data.color.concat('?timestamp=' + Date.now());
            if (response.data.thermal){
              this.$root.$emit('updateThermalSrc', response.data.thermal.concat('?timestamp=' + Date.now()));
            }
          }).catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          })
          .finally(() => {
            store.showLoadingOverlay(false)
          })
    },
    updateSrc(src){
      this.src = src;
    }
  },
  watch: {
    filterReport(filterReport){
      this.filter = filterReport;
    }
  },
  created() {
    this.getColorImage();
  },
  mounted() {
    this.$root.$on('updateColorSrc', this.updateSrc);
  },
  beforeDestroy() {
    this.$root.$off('updateColorSrc', this.updateSrc);
  },
  computed: {
    editable() {
      return store.state.currentReportStatus === 'NEW' || store.state.currentReportStatus === 'BRANCH_REQUEST_REJECTED' || store.state.currentReportStatus === 'AREA_REQUEST_REJECTED' || store.state.currentReportStatus === 'SUBMIT_REJECTED'
    },
  }
}
</script>

<style scoped>
span{
  display: inline-flex;
  align-items: center;
}
.div-rounded{
  display: inline-block;
  border: 1px solid #000000;
  border-radius:50%;
  height: 24px;
  width: 24px;
}
.cell{
  background: rgba(255, 109, 0, 1);
}
.multicell{
  background: rgba(255, 255, 0, 1);
}
.cluster{
  background: rgba(213, 0, 0, 1);
}
.string{
  background: rgba(64, 0, 124, 1);
}
.shadow{
  background: rgba(45, 121, 179, 1);
}
.module{
  background: rgba(150, 0, 61, 1);
}
.junction{
  background: rgba(76, 175, 80, 1);
}
.pid{
  background: rgba(27, 94, 32, 1);
}
.disabled{
  opacity: 0.6;
}
</style>
